import { overload } from "../../../shared/src/codecs/types/overload";
import { required } from "../../../shared/src/codecs/types/required";
import { literal } from "../../../shared/src/codecs/types/literal";
import { union } from "../../../shared/src/codecs/types/union";
import { array } from "../../../shared/src/codecs/types/array";
import { string } from "../../../shared/src/codecs/types/string";
import { TTypeOfCodec } from "../../../shared/src/codecs/codec";

export const NAME_DOES_NOT_MATCH = "name_does_not_match";
export const DATE_OF_BIRTH_DOES_NOT_MATCH = "date_of_birth_does_not_match";

export const ClientIdentityDetailsMismatch = overload(
    union([
        literal("none"),
        literal("name"),
        literal("date_of_birth"),
        literal("name_and_date_of_birth"),
    ]),
    required({
        identity_document_fail_reasons: array(string()),
    }),
    (p) => {
        const nameDoesNotMatch = p.identity_document_fail_reasons.includes(NAME_DOES_NOT_MATCH);
        const dateOfBirthDoesNotMatch = p.identity_document_fail_reasons.includes(DATE_OF_BIRTH_DOES_NOT_MATCH);

        return nameDoesNotMatch && dateOfBirthDoesNotMatch ? "name_and_date_of_birth"
            : nameDoesNotMatch ? "name"
            : dateOfBirthDoesNotMatch ? "date_of_birth"
            : "none";
    }
);
export type TClientIdentityDetailsMismatch = TTypeOfCodec<typeof ClientIdentityDetailsMismatch>;
